import { Input, InputAutoComplete } from '@nextgen-web-framework/all';
import { InputFieldProps } from './types/propTypes';
const AmwayPasswordField = (props: InputFieldProps) => {
  const {
    message,
    values,
    placeholder,
    name,
    onChange,
    onBlur,
    type,
    inputIconOnClick,
    status,
    onFocus,
    inputIcon,
    required,
    disabled,
  } = props;
  return (
    <Input
      value={values}
      data-testid={`${name}-input-test-id`}
      type={type}
      name={name}
      required={required}
      placeholder={placeholder}
      label={placeholder}
      onChange={onChange}
      minLength={8}
      inputIcon={inputIcon}
      inputIconOnClick={inputIconOnClick}
      onBlur={onBlur}
      status={status}
      message={message}
      onFocus={onFocus}
      disabled={disabled}
      autoComplete={InputAutoComplete.OFF}
    />
  );
};

export default AmwayPasswordField;
